function geral(){
	return {
			"games":[
				{
					"informs":[
						{
							"text":"A doença COVID-19 é transmitida através do contato com o vírus causador dessa infecção. Isso ocorre, principalmente, de uma pessoa contaminada para uma pessoa saudável.",
							"title":"Informações gerais sobre a doença",
							"image":"/images/games/informs/geral/1.png",
						},
						{
							"text":"Se esteve em contato com um indivíduo contaminado, fique isolado por 14 dias e use máscaras o tempo todo.",
							"title":"Informações gerais sobre a doença",
							"image":"/images/games/informs/geral/1.png",
						},
						{
							"text":"Preste atenção se tiver sintomas parecidos com os da gripe e, caso piore, procure um serviço médico.",
							"title":"Informações gerais sobre a doença",
							"image":"/images/games/informs/geral/1.png",
						},
						{
							"text":"Pessoas contaminadas que não apresentam sintomas (assintomáticos) transmitem o vírus tanto quanto as que apresentam os sintomas.",
							"title":"Informações gerais sobre a doença",
							"image":"/images/games/informs/geral/1.png",
						},
						{
							"text":"É muito importante que todos sigam os métodos de prevenção, principalmente o uso da máscara e distanciamento.",
							"title":"Informações gerais sobre a doença",
							"image":"/images/games/informs/geral/1.png",
						},
						{
							"text":"Existem pesquisas mundiais sendo realizadas no desenvolvimento de novos fármacos e na produção de vacinas para a COVID-19.",
							"title":"Informações gerais sobre a doença",
							"image":"/images/games/informs/geral/1.png",
						},
						{
							"text":"Atualmente, os resultados mais promissores do desenvolvimento de fármacos estão relacionados à criação de vacinas eficazes.",
							"title":"Informações gerais sobre a doença",
							"image":"/images/games/informs/geral/1.png",
						}
					],
					"pathImageGame":"midias/images/games/puzzles/geral/1.png"
				}
			]
		};
}

export {geral};
